import React, { useState, useEffect } from 'react';
import {
	Container,
	Button,
	Row,
	Col,
	InputGroup,
	FormControl,
} from 'react-bootstrap';
import { PlusCircleIcon } from '@primer/octicons-react';
import ClientsTable from './ClientsTable';
import { ReqGet } from '../../../config/Requests';
import { showLoader, hideLoader } from '../../../helper/loader';

function Clients({ _handleAddNewClient }) {
	const [search, setSearch] = useState('');
	const [filterList, setFilterList] = useState([]);
	const [clientsRaw, setClientsRaw] = useState([]);
	const [filterMessage, setFilterMessage] = useState('');
	useEffect(() => {
		if (search && filterList.length < 1) {
			setFilterMessage('No client found');
		} else {
			setFilterMessage('');
		}
	}, [search]);
	const updateSearch = event => {
		const valueToSearch = event.target.value;
		const filteredList = getFilterData(clientsRaw, valueToSearch);
		setFilterList(filteredList);
		console.log('filteredList', filteredList);
		setSearch(valueToSearch);
		console.log(filteredList);
	};

	const getFilterData = (list, valueToSearch = '') => {
		const lowercasedValue = valueToSearch.toLowerCase();
		return list.filter(doc => doc.name.toLowerCase().includes(lowercasedValue));
	};

	useEffect(() => {
		if (clientsRaw.length === 0) {
			// showLoader();
			ReqGet('clients').then(res => {
				hideLoader();
				setClientsRaw(res?.data?.data);
				setFilterList(res?.data?.data);
			});
		}
	}, []);

	return (
		<Container className='mt-3 p-0 pl-4' fluid={true}>
			<Row style={{ width: '100%' }} className='mb-3'>
				<Button
					className='btn-new-client'
					variant='primary'
					onClick={_handleAddNewClient}
				>
					<PlusCircleIcon size={16} /> Add new client
				</Button>
				<InputGroup
					style={{ width: '16%', 'margin-left': 'auto', marginRight: '15px' }}
				>
					<label
						style={{ cursor: 'pointer', display: 'flex' }}
						className='searchIcon'
					>
						<input
							type='text'
							name='close'
							aria-label='Search'
							value={search}
							id='close'
							onChange={updateSearch}
							className='form-control searchInput input'
							placeholder='Search '
						/>
						{/* <FormControl
              placeholder="Search"
              aria-label="Search"
              aria-describedby="basic-addon1"
              value={search}
              onChange={updateSearch}
            /> */}
					</label>
					{/* <InputGroup.Append >
            </InputGroup.Append> */}
				</InputGroup>
			</Row>
			<Row style={{ width: '100%' }}>
				<Col>
					{filterList && filterList.length > 0 ? (
						<ClientsTable data={filterList}></ClientsTable>
					) : (
						<div>
							{' '}
							<br />
							<br /> <p style={{ textAlign: 'center' }}>{filterMessage}</p>
						</div>
					)}
				</Col>
			</Row>
		</Container>
	);
}

export default Clients;
